import axios from 'axios';
import { api_labelflow, api_labelflow_training } from "../../../../config.jsx";

// Frame extraction lives on the training API: it owns Celery, and its business
// logic already writes the labeling collections. Project/model lookups come
// from the management API, reusing the endpoints the model pages use.

export const getEngineInfoAPI = () =>
  axios.get(`${api_labelflow_training}/video_management/engine_info`);

export const uploadVideoSourcesAPI = (formData, onUploadProgress) =>
  axios.post(`${api_labelflow_training}/video_management/upload_sources`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
  });

export const startExtractionAPI = (params) =>
  axios.post(
    `${api_labelflow_training}/video_management/start_extraction`,
    new URLSearchParams(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );

export const getVideoJobsAPI = (params) =>
  axios.get(`${api_labelflow_training}/video_management/jobs`, { params });

export const getVideoJobAPI = (params) =>
  axios.get(`${api_labelflow_training}/video_management/job`, { params });

export const getVideoJobLogsAPI = (params) =>
  axios.get(`${api_labelflow_training}/video_management/job_logs`, { params });

export const cancelVideoJobAPI = (params) =>
  axios.post(
    `${api_labelflow_training}/video_management/cancel_job`,
    new URLSearchParams(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );

// Reused from the management API — same calls the model pages make.
export const getProjectsDropdownAPI = (params) =>
  axios.get(`${api_labelflow}/model_management/get_projects_dd`, { params });

export const getModelsAPI = (params) =>
  axios.get(`${api_labelflow}/model_management/get_models`, { params });

// ---------------------------------------------------------------------------
// Standalone datasets (the holding area) + transfer into a project model
// ---------------------------------------------------------------------------

export const getDatasetsAPI = (params) =>
  axios.get(`${api_labelflow_training}/dataset_management/datasets`, { params });

export const getDatasetItemsAPI = (params) =>
  axios.get(`${api_labelflow_training}/dataset_management/dataset_items`, { params });

export const getModelVersionsAPI = (params) =>
  axios.get(`${api_labelflow_training}/dataset_management/model_versions`, { params });

export const transferToModelAPI = (params) =>
  axios.post(
    `${api_labelflow_training}/dataset_management/transfer_to_model`,
    new URLSearchParams(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );

export const deleteDatasetItemsAPI = (params) =>
  axios.delete(`${api_labelflow_training}/dataset_management/delete_items`, { params });

export const deleteDatasetAPI = (params) =>
  axios.delete(`${api_labelflow_training}/dataset_management/delete_dataset`, { params });

// ---------------------------------------------------------------------------
// Building a labeled model out of a dataset (the AI path)
// ---------------------------------------------------------------------------

export const startDatasetBuildAPI = (params) =>
  axios.post(
    `${api_labelflow_training}/dataset_management/start_build`,
    new URLSearchParams(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );

export const getDatasetBuildAPI = (params) =>
  axios.get(`${api_labelflow_training}/dataset_management/build`, { params });

export const getDatasetBuildsAPI = (params) =>
  axios.get(`${api_labelflow_training}/dataset_management/builds`, { params });

export const cancelDatasetBuildAPI = (params) =>
  axios.post(
    `${api_labelflow_training}/dataset_management/cancel_build`,
    new URLSearchParams(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );

// Creating a destination inline, so the user never has to leave the page to
// make a project or model first. Same management-API endpoints the project and
// model pages use — note both answer HTTP 200 with `data: null` on a duplicate
// name, so callers must branch on `message`, never on the status.
export const createProjectAPI = (formData) =>
  axios.post(`${api_labelflow}/project_management/save_project`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const createModelAPI = (formData) =>
  axios.post(`${api_labelflow}/model_management/save_model`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

/**
 * Download a dataset's images as a zip.
 *
 * POST, not GET: a selection can be hundreds of ids and would overflow a query
 * string. `responseType: 'blob'` because the body is the archive itself.
 */
export const downloadDatasetAPI = (params) =>
  axios.post(
    `${api_labelflow_training}/dataset_management/download_dataset`,
    new URLSearchParams(params),
    {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  );

/** How many images in a model version the AI could still label. */
export const getUnlabeledCountAPI = (params) =>
  axios.get(`${api_labelflow_training}/dataset_management/unlabeled_count`, { params });
